module.exports = __webpack_public_path__ + "media/add.c96862d6.svg";